import { Box } from "@components/Layout"
import { Label } from "@components/Typography"
import { breakpoints } from "@config/theme"
import styled from "styled-components"
import * as S from "../elements"

// @ts-ignore
export const Content = styled(Box)`
  ${S.BasicContentStyle};
  bottom: initial !important;
  padding: 0 1.5rem;
  top: 2rem;
  width: 100%;

  svg {
    height: 11px;
    width: 17px;
  }
`

export const ProductCombinationGrid = styled(Box)`
  display: grid;
  grid-template-columns: 100%;
  grid-row-gap: 1rem;
  grid-column-gap: 0;
  margin-bottom: 2rem;

  @media screen and (min-width: 720px) {
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 1.5rem;
    grid-row-gap: 1.5rem;
  }

  @media screen and (min-width: ${breakpoints.medium}) {
    grid-template-columns: repeat(3, 1fr);
    margin-bottom: 3rem;
  }
  @media screen and (min-width: ${breakpoints.xlarge}) {
    grid-template-columns: repeat(4, 1fr);
    margin-bottom: 4rem;
  }
`

// @ts-ignore
export const CatLabel = styled(Label)`
  position: absolute;
  top: 0;
  color: ${(p) => p.theme.colors.text.light};
  padding: 1rem 1.5rem;
`

export const Parent = styled.div<{ hasLifestyleImage: boolean }>`
  display: block;
  position: relative;
  color: ${(p) => p.theme.colors.text.dark};
  background: ${(p) => p.theme.colors.card.default};
  transition: background 0.1s ease-in-out;
  width: 100%;
  overflow: hidden;
  cursor: pointer;

  &::before {
    padding-top: 100%;
    content: "";
    display: block;
  }

  &::after {
    height: 100%;
    width: 100%;
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.5) 0%,
      rgba(0, 0, 0, 0) 20%,
      rgba(0, 0, 0, 0) 80%,
      rgba(0, 0, 0, 0.5) 100%
    );
    z-index: 0;
    transition-property: opacity;
    transition-duration: 0.15s;
    pointer-events: none;
    opacity: 0;
  }

  a,
  h3,
  span,
  svg {
    transition-property: color;
    transition-duration: 0.25s;
    z-index: 2;
  }

  &:hover {
    [data-product-image] {
      transform: translate(-50%, -50%) scale(1.05);
    }
    [data-hover-image] {
      opacity: 1;
      transform: scale(1);
    }
    ${CatLabel} {
      color: ${(p) => p.theme.colors.text.dark};
    }

    ${(p) =>
      p.hasLifestyleImage &&
      ` a,
        h3,
        span, svg {
          color: white;
        }

        &::after {
          opacity: 1;
        }
    `}
  }
`

export const Anchor = styled.a`
  color: ${(p) => p.theme.colors.text.dark};
`
